export const AlanDIcon = ({ onClick, ...props }) => {
    return (
        <svg 
        className="AlanDIcon" 
        version="1.0" x
        mlns="http://www.w3.org/2000/svg"
        width="50" 
        height="50" 
        viewBox="0 0 300.000000 300.000000"
        style={{ cursor: onClick ? 'pointer' : 'default' }}
        {...props}
        >
        <g transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)"
        >
        <path d="M830 2848 c0 -10 10 -43 21 -74 16 -43 18 -58 9 -64 -17 -10 -173
        -22 -202 -15 -12 3 -47 1 -77 -4 -73 -12 -145 6 -278 69 -58 27 -110 50 -115
        50 -38 0 127 -188 199 -227 39 -21 42 -40 9 -68 -13 -11 -41 -51 -61 -90 -45
        -84 -67 -105 -111 -105 -39 0 -46 -17 -9 -25 14 -3 36 -7 49 -10 23 -5 23 -5
        18 -118 -3 -71 -1 -121 6 -133 9 -17 11 -16 18 11 10 43 24 57 49 51 21 -5 22
        -4 12 33 -9 34 -7 44 20 92 23 41 38 57 64 65 26 9 39 22 56 56 26 55 71 94
        123 108 83 22 163 -25 221 -132 34 -63 34 -64 36 -203 2 -175 11 -263 32 -295
        l16 -25 -35 25 c-83 57 -290 207 -343 248 -31 25 -60 43 -63 39 -9 -9 275
        -672 327 -763 16 -28 29 -58 29 -65 0 -8 27 -72 60 -144 35 -75 60 -140 58
        -155 -2 -16 -18 -34 -45 -53 -46 -30 -56 -64 -28 -87 8 -7 15 -19 15 -26 0 -8
        8 -22 18 -32 26 -26 137 -16 162 15 17 22 17 21 23 -27 8 -66 60 -185 163
        -371 47 -85 115 -209 151 -276 35 -68 69 -123 73 -123 5 0 43 66 85 148 43 81
        90 166 105 188 15 23 31 52 35 65 4 13 25 40 46 60 34 31 39 42 40 80 0 25 15
        81 33 129 33 85 34 85 67 83 19 -2 43 -3 54 -2 11 0 44 1 73 2 50 0 52 1 52
        28 0 15 11 41 25 57 14 17 25 36 25 44 0 18 -25 40 -64 56 -28 13 -29 14 -24
        80 4 52 14 85 45 147 22 44 75 163 118 265 42 102 122 290 177 418 55 128 98
        239 96 247 -2 10 -36 -8 -108 -58 -58 -40 -150 -103 -205 -141 -55 -37 -106
        -75 -114 -84 -12 -15 -13 -15 -6 3 13 37 39 210 39 267 0 31 -6 74 -13 96 -13
        38 -12 43 23 115 52 109 129 167 220 167 66 0 146 -57 173 -122 11 -27 22 -38
        43 -43 32 -7 60 -35 89 -90 25 -47 25 -52 7 -87 -14 -27 -14 -27 14 -21 26 5
        30 2 36 -23 21 -93 21 -93 28 -34 4 30 6 100 4 155 l-3 100 41 3 c25 2 49 11
        59 22 16 17 15 18 -20 6 -43 -15 -85 -10 -85 11 0 20 -36 88 -81 155 -22 32
        -39 61 -39 66 0 4 36 33 80 65 78 57 160 145 160 172 0 10 -32 0 -102 -32
        -147 -64 -237 -86 -308 -73 -30 6 -80 8 -111 4 -45 -5 -66 -2 -104 15 l-48 21
        5 50 c3 28 1 53 -3 56 -5 3 -6 -3 -2 -12 4 -11 2 -15 -4 -11 -6 4 -17 -1 -24
        -11 -13 -15 -12 -16 4 -3 17 13 18 12 11 -15 -10 -42 -16 -46 -77 -48 -42 -1
        -62 4 -85 21 l-29 21 5 -51 c2 -29 8 -56 13 -61 5 -6 9 -20 9 -32 0 -31 -56
        -135 -85 -159 l-24 -20 49 0 c28 0 50 3 50 8 0 4 -9 7 -21 7 -15 0 -19 4 -15
        16 3 9 6 19 6 23 0 11 55 67 77 80 17 8 26 7 44 -8 l23 -18 -52 -66 c-29 -37
        -52 -70 -52 -73 0 -13 43 31 73 76 17 25 32 47 33 49 2 2 17 -2 33 -9 l30 -12
        -38 -47 c-50 -59 -81 -119 -80 -151 1 -22 3 -21 18 13 25 53 38 64 46 39 6
        -21 -18 -81 -39 -94 -14 -9 -46 20 -46 43 0 39 -134 106 -186 93 -26 -7 -33
        -24 -10 -24 22 0 87 -40 118 -72 14 -15 32 -28 40 -28 20 0 78 -62 78 -84 0
        -10 7 -43 16 -73 15 -51 15 -60 -5 -161 -12 -59 -21 -120 -21 -136 0 -16 -7
        -38 -16 -47 -16 -18 -17 -17 -36 6 -11 14 -25 25 -31 25 -28 1 -39 17 -28 39
        16 28 -3 27 -23 -1 -21 -29 -20 -61 1 -101 l18 -32 3 32 c2 17 9 37 17 43 11
        9 17 0 33 -42 22 -60 48 -71 101 -44 16 9 43 16 60 16 27 0 30 -3 36 -50 5
        -38 2 -64 -14 -110 -12 -33 -21 -75 -21 -93 0 -42 -42 -130 -71 -151 -25 -17
        -79 -22 -79 -7 0 5 15 15 34 21 24 8 44 26 65 59 42 65 39 74 -6 17 -25 -30
        -46 -46 -60 -46 -16 0 -31 -13 -48 -40 -14 -22 -30 -40 -35 -40 -15 0 43 99
        68 116 11 8 39 33 62 56 33 34 40 48 38 73 -3 26 -8 31 -38 35 -33 5 -34 6
        -13 18 32 18 54 15 60 -8 6 -23 23 -17 23 9 0 10 -12 21 -27 27 l-27 9 38 37
        c45 43 34 55 -25 29 -38 -17 -54 -18 -114 -11 -38 5 -136 9 -216 10 -131 0
        -149 -2 -172 -20 -20 -16 -40 -20 -101 -20 -42 0 -76 4 -76 8 0 32 -228 44
        -412 21 -78 -9 -90 -8 -130 9 -23 11 -46 18 -49 16 -19 -12 -18 -74 3 -139 21
        -63 23 -67 29 -40 l7 30 1 -27 c2 -48 19 -76 66 -108 26 -18 44 -34 41 -37
        -10 -10 -45 9 -80 43 -21 20 -33 27 -29 17 12 -35 57 -90 86 -107 38 -21 28
        -31 -16 -17 -29 10 -39 22 -61 70 -14 32 -26 66 -26 75 0 8 -11 45 -25 82 -27
        72 -31 108 -15 149 9 24 14 27 48 22 20 -2 51 -10 69 -18 27 -11 39 -10 89 7
        49 17 59 24 77 62 12 23 24 42 28 42 12 0 -3 85 -17 96 -9 7 -33 9 -61 6 -43
        -5 -46 -4 -40 17 3 11 2 21 -3 21 -13 0 -18 38 -7 49 6 6 7 11 3 11 -5 0 -3 6
        3 14 9 11 6 12 -14 8 -26 -4 -34 11 -13 24 7 5 4 10 -10 15 -25 9 -42 46 -42
        89 0 32 29 90 46 90 6 0 17 7 24 15 7 9 15 13 18 10 3 -3 12 5 19 17 7 13 12
        17 13 11 0 -21 30 -15 30 6 0 47 40 81 97 81 l28 1 -28 15 c-25 14 -34 14 -82
        0 -29 -9 -56 -16 -59 -16 -3 0 -31 35 -63 77 -37 49 -53 78 -45 81 7 2 19 10
        27 19 23 23 49 11 61 -27 9 -28 13 -31 16 -15 4 17 8 13 21 -17 20 -45 21 -49
        5 -47 -30 4 -42 -1 -31 -12 8 -8 17 -8 32 0 15 8 27 9 40 1 32 -17 36 -11 7
        11 -14 11 -26 28 -26 38 0 10 -13 37 -30 59 -34 47 -36 60 -15 88 22 29 18 33
        -15 21 -24 -9 -35 -9 -53 3 -12 7 -33 19 -47 27 -24 12 -22 13 27 13 42 0 57
        5 80 26 30 27 28 27 -31 0 -23 -10 -49 -15 -65 -11 -27 6 -62 50 -55 70 2 6
        -5 21 -16 35 -15 20 -20 21 -20 8z m1919 -116 c-51 -39 -100 -64 -115 -58 -8
        3 -13 2 -10 -3 3 -5 -11 -16 -32 -24 -60 -24 -126 -30 -179 -17 -48 12 -173 3
        -217 -15 -14 -6 -17 -5 -12 3 13 22 -23 12 -38 -10 -18 -26 -13 -36 9 -18 27
        22 186 31 274 15 l44 -8 -48 -19 c-35 -14 -62 -18 -95 -13 -40 5 -92 -1 -155
        -19 -14 -4 -32 5 -60 30 -29 26 -33 33 -15 24 22 -10 21 -8 -8 19 -18 17 -40
        31 -49 31 -11 0 -6 8 17 25 28 21 45 25 94 24 47 -1 55 -3 36 -9 -17 -6 8 -9
        80 -11 288 -4 278 -5 380 34 107 40 134 45 99 19z m-636 -22 c-23 -4 -51 -14
        -62 -24 -23 -21 -74 -18 -79 5 -2 13 12 18 80 25 85 10 137 4 61 -6z m-1176
        -35 c19 -17 23 -24 13 -25 -9 0 -31 -13 -50 -29 l-35 -29 -28 24 c-16 13 -38
        24 -50 24 -18 0 -19 -2 -7 -10 18 -13 -35 -3 -62 11 -9 5 -59 9 -110 10 l-93
        1 85 14 c47 7 122 13 168 14 48 0 82 4 82 10 0 20 59 10 87 -15z m-458 -11 c2
        -2 -10 -4 -27 -4 -17 0 -34 4 -37 10 -5 9 53 3 64 -6z m66 -34 c7 -12 -29 -12
        -65 0 -21 7 -19 8 17 9 23 1 45 -3 48 -9z m1480 -20 c-3 -5 -11 -10 -16 -10
        -6 0 -7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z m-1195 -35 c11 -13 7 -15
        -22 -15 -20 0 -57 3 -84 7 l-49 8 55 6 c30 3 62 6 71 7 9 1 22 -5 29 -13z
        m1833 -179 l39 -71 -31 29 c-33 32 -44 17 -13 -17 11 -12 21 -51 29 -105 13
        -98 10 -117 -8 -49 -6 26 -17 52 -25 58 -8 6 -14 21 -14 33 0 11 -7 30 -15 40
        -8 11 -15 39 -15 63 0 41 -23 98 -62 155 -34 49 -18 43 30 -11 26 -30 64 -86
        85 -125z m-236 157 c-4 -3 -10 -3 -14 0 -3 4 0 7 7 7 7 0 10 -3 7 -7z m-1479
        -92 l62 -69 -36 -21 c-41 -25 -44 -25 -44 -8 0 7 -18 42 -39 78 -28 46 -36 68
        -29 77 6 6 13 12 17 12 4 0 35 -31 69 -69z m1028 -116 l29 -23 -27 5 c-14 3
        -36 16 -48 28 -21 22 -21 23 -3 19 11 -3 33 -16 49 -29z m444 -339 c0 -25
        -240 -597 -337 -805 -30 -63 -57 -134 -60 -158 -9 -65 -44 -93 -73 -58 -9 11
        -9 22 -1 46 6 18 11 64 11 104 0 59 5 81 26 119 18 33 32 46 48 46 55 0 108
        82 126 194 6 36 15 77 20 91 6 15 10 53 10 86 0 66 -21 99 -64 99 -19 0 -44
        26 -34 35 2 2 71 48 153 104 132 88 175 112 175 97z m-468 -350 c11 -15 -2
        -155 -16 -186 -18 -40 -76 -62 -160 -62 -69 0 -138 20 -135 40 1 4 1 14 0 22
        -1 13 -2 13 -11 0 -5 -8 -10 -18 -10 -22 0 -16 49 -38 119 -53 70 -15 76 -14
        132 6 32 12 64 29 72 38 7 9 26 50 42 91 28 73 29 74 36 43 3 -18 14 -44 24
        -59 16 -24 16 -28 1 -42 -12 -12 -16 -13 -16 -3 0 8 -18 -9 -40 -37 -42 -52
        -57 -62 -95 -62 -13 0 -27 -4 -30 -10 -3 -5 -15 -10 -26 -10 -21 0 -25 -10 -8
        -27 8 -8 -4 -18 -44 -36 -44 -20 -58 -33 -76 -69 -23 -48 -26 -73 -11 -83 6
        -4 10 7 10 27 0 18 9 48 20 66 25 40 36 42 15 2 -9 -16 -12 -30 -7 -30 4 0 6
        -17 4 -37 -2 -29 5 -50 28 -85 46 -73 66 -64 95 40 17 61 45 104 31 47 -4 -15
        -9 -41 -11 -59 -5 -30 -4 -29 5 4 18 59 32 90 41 90 15 0 10 -127 -7 -196 -18
        -70 -25 -79 -149 -187 -128 -113 -122 -110 -184 -102 -31 4 -62 12 -68 17 -8
        6 -13 34 -13 69 0 65 12 79 69 79 33 0 42 16 14 23 -10 3 -3 5 15 6 42 1 33
        18 -16 27 l-37 7 43 15 c56 18 47 27 -15 14 -54 -12 -124 -10 -197 7 -62 15
        -69 8 -14 -14 50 -20 34 -33 -21 -16 -20 6 -45 12 -56 13 -16 3 -13 8 20 28
        35 22 53 25 150 28 173 4 182 3 222 -13 31 -13 39 -13 50 -2 11 11 11 23 1 68
        -11 49 -13 51 -16 22 -4 -36 -18 -44 -25 -15 -4 13 -5 11 -6 -5 -1 -22 -5 -23
        -91 -23 -49 0 -90 4 -90 9 0 17 50 41 86 41 33 0 36 -2 31 -22 -6 -22 -5 -22
        8 -4 29 39 -40 66 -103 40 -29 -12 -37 -11 -58 2 -23 15 -59 15 -116 -2 -15
        -4 -18 1 -19 28 l-1 33 -9 -31 c-5 -17 -16 -38 -26 -45 -15 -13 -16 -10 -11
        36 4 27 2 58 -4 68 -8 16 -7 17 11 7 12 -6 21 -16 21 -22 0 -6 3 -9 6 -5 3 3
        -4 19 -16 35 -14 19 -20 37 -16 48 5 13 12 9 36 -25 40 -55 47 -52 14 5 -24
        40 -25 48 -14 70 10 18 16 21 27 13 7 -6 13 -20 13 -30 0 -36 23 -69 54 -77
        26 -7 32 -14 34 -40 2 -18 8 -30 13 -27 5 4 9 1 9 -4 0 -16 21 -13 42 6 25 22
        23 48 -8 89 -24 31 -26 38 -17 77 l11 42 1 -42 c1 -53 9 -73 29 -73 33 0 52
        31 52 87 0 29 -4 53 -10 53 -5 0 -13 12 -17 28 -15 60 -44 113 -61 110 -22 -4
        -58 -70 -66 -119 -3 -22 -11 -39 -16 -39 -6 0 -10 -19 -10 -42 0 -48 22 -78
        57 -78 26 0 31 -15 7 -24 -32 -12 -73 26 -99 92 -17 42 -17 43 9 80 14 21 26
        44 26 50 0 7 16 49 36 92 47 103 61 104 109 10 19 -38 35 -82 35 -98 0 -17 10
        -38 25 -52 14 -13 25 -28 25 -33 0 -5 15 -24 34 -42 28 -26 32 -35 23 -51 -9
        -17 -8 -17 14 2 13 12 38 25 54 29 25 7 26 9 10 13 -11 2 -26 13 -33 23 -7 11
        -25 19 -41 19 -15 0 -34 6 -42 13 -23 19 -48 63 -47 83 0 11 -16 54 -36 97
        l-37 79 -44 -4 c-46 -3 -52 6 -11 16 30 7 76 -9 76 -26 0 -20 60 -142 66 -135
        3 3 26 -5 51 -19 49 -26 110 -31 146 -13 32 17 77 61 77 76 0 21 -16 15 -28
        -12 -17 -36 -70 -65 -117 -64 l-40 2 35 7 35 7 -30 2 c-17 0 -41 8 -53 17 -13
        9 -26 14 -29 11 -2 -3 8 -12 24 -21 15 -8 23 -15 17 -16 -17 0 -47 26 -50 44
        -3 19 -3 19 33 5 21 -8 46 -8 96 2 75 14 97 27 39 23 -20 -1 -70 0 -109 3
        l-73 5 0 39 c0 39 0 39 40 39 36 0 40 -2 40 -25 0 -20 5 -25 26 -25 19 0 25 4
        20 15 -3 8 2 21 10 30 14 13 8 15 -61 15 -57 0 -76 3 -73 13 3 8 33 13 90 15
        l86 3 41 -43 41 -43 -11 33 c-13 39 -3 55 17 28 20 -28 18 -6 -2 23 -16 23
        -16 23 7 16 13 -4 27 -13 31 -19z m-1057 -36 c3 -5 4 -10 1 -10 -3 0 -8 5 -11
        10 -3 6 -4 10 -1 10 3 0 8 -4 11 -10z m385 -23 l28 11 -19 -45 c-24 -56 -24
        -63 1 -63 18 0 19 3 8 20 -18 29 0 38 20 9 9 -13 16 -27 14 -31 -1 -5 11 -8
        27 -8 20 0 35 8 45 22 18 25 21 17 6 -13 -6 -10 -21 -19 -33 -19 -40 0 -97
        -21 -97 -35 0 -23 17 -26 55 -11 22 10 33 11 29 4 -5 -8 -2 -9 9 -5 13 5 12
        -1 -7 -31 -23 -36 -25 -37 -101 -44 -61 -6 -84 -4 -107 8 -42 22 -27 29 17 8
        23 -10 39 -13 43 -7 4 5 34 17 66 26 33 9 64 21 69 26 5 5 -10 3 -34 -6 -50
        -17 -161 -11 -215 12 -41 17 -52 49 -28 77 11 11 24 32 31 46 10 24 11 20 12
        -39 1 -73 18 -94 51 -64 9 8 23 16 31 16 8 1 -3 5 -24 8 -48 8 -53 25 -8 29
        25 3 31 6 20 13 -11 7 -11 9 4 9 9 0 17 -7 17 -15 0 -8 6 -15 14 -15 16 0 31
        73 15 79 -6 2 -22 14 -37 27 l-27 24 38 -17 c30 -14 44 -15 67 -6z m-250 -107
        c0 -8 9 -32 20 -53 22 -41 10 -51 -16 -12 -18 28 -33 120 -15 95 6 -8 11 -22
        11 -30z m-189 -101 c-9 -22 -10 -22 -10 -3 -1 11 2 24 6 27 12 12 14 0 4 -24z
        m721 -111 c-7 -7 -12 -8 -12 -2 0 6 3 14 7 17 3 4 9 5 12 2 2 -3 -1 -11 -7
        -17z m-458 -28 c-6 -6 -28 -13 -50 -15 l-39 -5 40 14 c50 17 62 19 49 6z m119
        -95 c34 -5 37 -8 37 -40 0 -18 7 -40 15 -49 14 -13 14 -19 1 -48 -9 -22 -15
        -27 -15 -14 -1 15 -6 13 -37 -14 -31 -26 -42 -31 -69 -26 -37 7 -52 -12 -35
        -45 15 -27 -2 -24 -30 6 -27 28 -42 117 -29 170 l7 30 1 -30 c3 -82 25 -137
        33 -83 4 30 24 34 38 7 11 -19 10 -21 -5 -16 -11 5 -15 3 -13 -5 3 -7 21 -14
        41 -16 31 -3 42 2 67 30 28 30 30 37 24 78 -8 52 -16 60 -64 60 -19 0 -42 5
        -50 11 -11 8 -8 9 15 5 17 -2 47 -7 68 -11z m242 -68 c27 -20 10 -40 -28 -33
        -35 7 -52 27 -34 38 18 12 41 10 62 -5z m625 -197 c0 -5 -7 -7 -15 -4 -8 4
        -15 8 -15 10 0 2 7 4 15 4 8 0 15 -4 15 -10z m-600 -76 l0 -66 -37 6 c-21 4
        -59 9 -85 12 -84 10 -79 28 16 58 46 14 86 33 90 41 11 30 16 14 16 -51z m-40
        46 c-8 -5 -24 -10 -35 -10 -17 0 -17 2 -5 10 8 5 24 10 35 10 17 0 17 -2 5
        -10z"/>
        <path d="M2135 2655 c32 -14 41 -13 30 4 -3 6 -18 11 -33 10 l-27 -1 30 -13z"/>
        <path d="M2584 2664 c-7 -3 -41 -9 -75 -14 l-64 -9 68 4 c37 2 75 9 85 14 17
        10 7 14 -14 5z"/>
        <path d="M831 2661 c-23 -15 3 -19 34 -5 29 13 29 13 5 13 -14 1 -31 -3 -39
        -8z"/>
        <path d="M2605 2450 c9 -16 18 -30 21 -30 2 0 -2 14 -11 30 -9 17 -18 30 -21
        30 -2 0 2 -13 11 -30z"/>
        <path d="M1823 1623 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"/>
        <path d="M1855 1600 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
        0 -7 -4 -4 -10z"/>
        <path d="M1855 1570 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
        -7 -4 -4 -10z"/>
        <path d="M1597 1260 c-10 -16 -13 -30 -8 -30 6 0 17 14 26 30 9 17 12 30 7 30
        -4 0 -16 -13 -25 -30z"/>
        <path d="M1660 1093 c0 -12 5 -25 10 -28 13 -8 13 15 0 35 -8 12 -10 11 -10
        -7z"/>
        <path d="M1861 1014 c-13 -13 -22 -26 -19 -29 6 -6 48 33 48 45 0 13 0 12 -29
        -16z"/>
        <path d="M1766 971 c-5 -42 -16 -76 -33 -102 -22 -34 -31 -39 -64 -39 -21 0
        -49 4 -63 10 -15 5 -26 6 -26 1 0 -16 70 -33 105 -27 21 4 47 21 71 49 21 23
        42 41 46 40 11 -4 10 41 -1 53 -5 5 -14 25 -19 44 -8 34 -9 33 -16 -29z"/>
        <path d="M1806 991 c4 -8 10 -28 14 -45 6 -28 7 -29 12 -8 4 14 -1 30 -14 45
        -11 12 -16 16 -12 8z"/>
        <path d="M1595 740 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
        -13 -4 -16 -10z"/>
        <path d="M870 2796 c0 -13 62 -36 92 -35 32 1 32 2 -7 8 -22 4 -50 13 -62 19
        -13 7 -23 10 -23 8z"/>
        <path d="M2023 2763 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"/>
        <path d="M2053 2763 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"/>
        <path d="M1490 2546 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
        13z"/>
        <path d="M1538 2513 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
        <path d="M1410 2460 c0 -21 16 -44 23 -33 4 6 0 19 -8 29 -11 15 -14 16 -15 4z"/>
        <path d="M1235 2420 c-3 -5 0 -10 7 -10 7 0 24 -3 38 -7 22 -6 24 -5 11 10
        -15 19 -46 23 -56 7z"/>
        <path d="M1337 2383 c12 -26 23 -57 23 -70 0 -13 5 -23 10 -23 19 0 -24 119
        -48 134 -5 3 2 -16 15 -41z"/>
        <path d="M1740 2401 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
        3 -10 2 -10 -4z"/>
        <path d="M1464 2322 c1 -39 3 -47 10 -32 5 12 5 33 -1 52 -9 31 -9 30 -9 -20z"/>
        <path d="M1390 2350 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"/>
        <path d="M1443 2300 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
        <path d="M1532 2308 c-1 -26 1 -30 9 -15 6 10 6 23 1 33 -7 12 -9 8 -10 -18z"/>
        <path d="M1250 2324 c0 -5 7 -19 15 -30 8 -10 15 -14 15 -8 0 5 -7 19 -15 30
        -8 10 -15 14 -15 8z"/>
        <path d="M1401 2314 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
        <path d="M1290 2315 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
        -5 8 -10 11 -10 5z"/>
        <path d="M1712 2295 c-7 -15 -11 -30 -8 -32 7 -7 28 36 24 49 -2 6 -9 -2 -16
        -17z"/>
        <path d="M1784 2298 c-4 -7 -3 -8 4 -4 12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"/>
        <path d="M1556 2283 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
        <path d="M1870 2259 c-22 -18 -22 -19 -3 -10 12 6 25 16 28 21 9 15 3 12 -25
        -11z"/>
        <path d="M1493 2250 c-11 -16 -10 -18 2 -14 8 4 15 12 15 20 0 19 -3 18 -17
        -6z"/>
        <path d="M1228 2253 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
        <path d="M1098 2201 c8 -4 45 -6 83 -3 59 4 75 2 97 -15 47 -34 58 -36 24 -4
        -31 30 -35 31 -125 31 -54 0 -86 -4 -79 -9z"/>
        <path d="M953 2173 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"/>
        <path d="M975 2153 c-16 -3 -34 -9 -39 -14 -15 -14 43 -11 94 5 45 15 45 15
        10 14 -19 -1 -48 -3 -65 -5z"/>
        <path d="M1990 2156 c0 -2 9 -6 20 -9 11 -3 20 -1 20 4 0 5 -9 9 -20 9 -11 0
        -20 -2 -20 -4z"/>
        <path d="M2018 2113 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
        <path d="M1265 2040 c-21 -22 -36 -42 -34 -45 3 -2 22 16 43 40 46 56 42 58
        -9 5z"/>
        <path d="M2008 2043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
        <path d="M1200 1973 c0 -24 36 -53 92 -73 75 -28 98 -42 115 -72 7 -13 12 -18
        13 -12 0 26 -43 63 -102 84 -35 13 -75 36 -90 52 -16 17 -28 26 -28 21z"/>
        <path d="M1475 1863 c15 -14 29 -102 23 -148 -2 -21 -10 -31 -28 -36 -21 -6
        -20 -7 12 -8 21 -1 59 8 86 18 35 14 89 22 183 27 101 5 127 9 104 16 -40 11
        -256 -8 -302 -27 -19 -8 -37 -15 -39 -15 -9 0 -3 167 5 176 6 5 -2 9 -23 10
        -28 0 -32 -2 -21 -13z"/>
        <path d="M1731 1854 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
        <path d="M1090 1726 c-22 -13 -8 -15 145 -19 94 -3 185 -8 204 -12 21 -5 32
        -4 28 2 -8 13 -128 31 -252 38 -76 4 -106 2 -125 -9z"/>
        </g>
        </svg>

    );
  };